import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47170297"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "employee-multiselect" }
const _hoisted_2 = { class: "employee-multiselect__button-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Сотрудник:", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "employee-multiselect__button-users"
}
const _hoisted_6 = { class: "employee-multiselect__tooltip-text" }
const _hoisted_7 = {
  key: 0,
  class: "employee-multiselect__selected-options"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "employee-multiselect__name" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "employee-multiselect__name" }

import { computed, onMounted, PropType, ref, watch } from 'vue';
import {
  PopoverColorEnum,
  PopoverPositionEnum,
  TirCheckbox,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirPmPopover,
  TirPmScrollbar,
  TirPmTooltipElement,
} from 'tir-components';
import { TirPmMultiselect } from 'tir-pm-multiselect';
import { UserCircleIcon } from 'tir-style-system/icons/outline';
import { UserModel } from '@/components/task-forms/models';
import { EmployeeMultiselectOptionModel } from './models';
import EnumUserStatus from '@/api/Main/dataSource/api/users/base/enums/EnumUserStatus';

// #region defineProps

export default /*#__PURE__*/_defineComponent({
  __name: 'employee-multiselect',
  props: {
  /**Статус филтра */
  statusFilter: { type: String },
  /**Идентификаторы выбранных сотрудников */
  modelValue: {
    type: Array as PropType<Array<number>>,
    default: [],
  },
  /**Список сотрудников */
  employees: {
    type: Array as PropType<Array<UserModel>>,
    default: [],
  },
  popoverWidth: { type: String, default: '32rem' },
  /**Позиция поповера */
  popoverPosition: {
    type: Object,
    default: () => ({
      left: '0rem',
      top: '$el:height + 0.25rem',
    }),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "open"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;


// #endregion defineProps

// #region defineEmits

// #endregion defineEmits

// #region refs
/**Строка поиска */
const searchStr = ref('');
/**Компонент мультиселекта */
const $multiselect = ref();
// #endregion refs

// #region computed
/**Опции для мультиселекта */
const options = computed(() =>
  props.employees.map(
    (employee) =>
      new EmployeeMultiselectOptionModel({
        Id: employee.Id,
        FirstName: employee.FirstName,
        LastName: employee.LastName,
        AvatarColor: employee.AvatarColor,
        ImageUrl: employee.ImageUrl,
      }),
  ),
);
/**Не выбранные опции */
const unselectOptions = computed(() => {
  return options.value
    .filter(
      (option) =>
        !props.modelValue.some((employeeId) => option.Id === employeeId) &&
        (!searchStr.value || option.search(searchStr.value)),
    )
    .sort((a, b) => a.FirstAndLastName.localeCompare(b.FirstAndLastName));
});
/**Выбранные опции */
const selectedOptions = computed(() =>
  options.value
    .filter((option) => props.modelValue.some((employeeId) => option.Id === employeeId))
    .sort((a, b) => a.FirstAndLastName.localeCompare(b.FirstAndLastName)),
);

// #endregion computed

// #region Функции
/**Выбрать / убрать выбор сотрудника */
const toggleEmployee = (employeeId: number) => {
  let newValue = [...props.modelValue];
  // Если сотрудник уже был выбран
  if (props.modelValue.includes(employeeId)) {
    newValue = newValue.filter((_employeeId) => employeeId !== _employeeId);
  } else {
    newValue.push(employeeId);
  }

  emit('update:modelValue', newValue);
};
/**Закрыть компонент */
const close = () => {
  $multiselect.value?.close?.();
};
// #endregion Функции

/**Код для использования по ref */
__expose({ close });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmMultiselect), {
      ref_key: "$multiselect",
      ref: $multiselect,
      isDisabled: __props.statusFilter === String(_unref(EnumUserStatus).Dismissed) || __props.disabled,
      options: options.value,
      "popover-width": __props.popoverWidth,
      "disable-content-blur": true,
      "popover-position": __props.popoverPosition,
      onUpdateSearch: _cache[1] || (_cache[1] = ($event: any) => (searchStr.value = $event)),
      onOnOpen: _cache[2] || (_cache[2] = ($event: any) => (emit('open')))
    }, {
      target: _withCtx(() => [
        _renderSlot(_ctx.$slots, "target", {}, () => [
          _createVNode(_unref(TirPmButton), {
            variant: _unref(TirPmButtonVariantEnum).LinkState,
            size: _unref(TirPmButtonSizeEnum).Small
          }, {
            leftSlot: _withCtx(() => [
              _createVNode(_unref(UserCircleIcon))
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                (!selectedOptions.value.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Все"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptions.value, (option, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: _normalizeStyle({ transform: `translateX(-${0.25 * index}rem)` })
                        }, [
                          _createVNode(_unref(TirPmTooltipElement), null, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, _toDisplayString(option.FirstAndLastName), 1)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_unref(TirPmIconView), {
                                size: 24,
                                "image-load-url": option.ImageUrl,
                                "color-code": option.AvatarColor,
                                "is-rounded": "",
                                "is-bordered": false
                              }, {
                                mainSlot: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(option.FirstAndFirstLetterFullname), 1)
                                ]),
                                _: 2
                              }, 1032, ["image-load-url", "color-code"])
                            ]),
                            _: 2
                          }, 1024)
                        ], 4))
                      }), 256))
                    ]))
              ])
            ]),
            _: 1
          }, 8, ["variant", "size"])
        ])
      ]),
      optionsContent: _withCtx(() => [
        _createVNode(_unref(TirPmScrollbar), {
          style: {"max-height":"12rem","min-height":"12rem"},
          "show-on-hover": true,
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, {
          default: _withCtx(() => [
            (selectedOptions.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptions.value, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: "employee-multiselect__option",
                      key: option.Id,
                      onClick: ($event: any) => (toggleEmployee(option.Id))
                    }, [
                      _createVNode(_unref(TirCheckbox), { "model-value": true }),
                      _createVNode(_unref(TirPmIconView), {
                        size: 24,
                        "image-load-url": option.ImageUrl,
                        "color-code": option.AvatarColor,
                        "is-rounded": "",
                        "is-bordered": false
                      }, {
                        mainSlot: _withCtx(() => [
                          _createTextVNode(_toDisplayString(option.FirstAndFirstLetterFullname), 1)
                        ]),
                        _: 2
                      }, 1032, ["image-load-url", "color-code"]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(option.FirstAndLastName), 1)
                    ], 8, _hoisted_8))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unselectOptions.value, (option) => {
              return (_openBlock(), _createElementBlock("label", {
                class: "employee-multiselect__option",
                key: option.Id,
                onClick: ($event: any) => (toggleEmployee(option.Id))
              }, [
                _createVNode(_unref(TirCheckbox)),
                _createVNode(_unref(TirPmIconView), {
                  size: 24,
                  "image-load-url": option.ImageUrl,
                  "color-code": option.AvatarColor,
                  "is-rounded": "",
                  "is-bordered": false
                }, {
                  mainSlot: _withCtx(() => [
                    _createTextVNode(_toDisplayString(option.FirstAndFirstLetterFullname), 1)
                  ]),
                  _: 2
                }, 1032, ["image-load-url", "color-code"]),
                _createElementVNode("span", _hoisted_11, _toDisplayString(option.FirstAndLastName), 1)
              ], 8, _hoisted_10))
            }), 128))
          ]),
          _: 1
        }),
        _renderSlot(_ctx.$slots, "optionsContentFooter")
      ]),
      _: 3
    }, 8, ["isDisabled", "options", "popover-width", "popover-position"])
  ]))
}
}

})